import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/recruit_mid.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename='/recruit/mid'>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

